import styled from "styled-components";

export const HideWebCamStyled = styled.div`
    video {
        position: absolute;
        right: 100%;
    }
`;
